import { useContext, useEffect } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { BlogHeaderLinks } from '../../components/blogs/BlogHeaderLinks'
import { getArticleDateTime } from '../../utils/article-date-time'
import { BlogsList } from '../../components/blogs/BlogList'
import { blogsMaster } from '../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../lib/service'
import { getWpHealthFitness, getWpNewHealthFitness, setWpHealthFitness, setWpNewHealthFitness } from '../../service/wp-blogs-store'

export async function getStaticProps() {

    const { modifiedDate, month, year } = getArticleDateTime();
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = getWpHealthFitness().length > 0 ?  getWpHealthFitness() : await getWpPostsByCategory(6, "health-fitness");
    setWpHealthFitness(wpPosts)
    const wpNewPosts = getWpNewHealthFitness().length > 0 ?  getWpNewHealthFitness() : await getWpNewPostsByCategory(6, "health-fitness");
    setWpNewHealthFitness(wpNewPosts)

  return {
      props: {
        modifiedDate,
        month,
        year,
        fitnessBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>Benefits of bodycombat workout you need to know!</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="BodyCombat is a combination of Taekwondo, Kickboxing, Karate, Muay Thai, Tai Chi etc. for muscle strengthening, flexibility, core strengthening & weight loss."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/blogs/body-combat-trainer" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Benefits of body combat workout you need to know!`}/>
        <meta property="og:description" content="BodyCombat is a combination of Taekwondo, Kickboxing, Karate, Muay Thai, Tai Chi etc. for muscle strengthening, flexibility, core strengthening & weight loss." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-30T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/body-combat.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/body-combat.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/blogs/body-combat-trainer"/>
        <meta name="twitter:title" content={`Benefits of bodycombat workout you need to know!`}/> 
        <meta name="twitter:description" content="BodyCombat is a combination of Taekwondo, Kickboxing, Karate, Muay Thai, Tai Chi etc. for muscle strengthening, flexibility, core strengthening & weight loss."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/blogs/body-combat-trainer" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/blogs/body-combat-trainer"},"headline":"Benefits of bodycombat workout you need to know!","description":"BodyCombat is a combination of Taekwondo, Kickboxing, Karate, Muay Thai, Tai Chi etc. for muscle strengthening, flexibility, core strengthening & weight loss.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/health+and+fitness/body-combat.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-30T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/blogs"},{"@type":"ListItem","position":1,"name":"bodycombat-class"}]}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-5 px-2'>
            <div className='space-y-2'>
                <h1 className='text-lg text-gray-500 font-semibold'>Benefits of BodyCombat workout you need to know!</h1>
                <div className='text-gray-400 text-xs'>
                <time dateTime={modifiedDate}>{new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                </div>
            </div>
            <div className='py-2 text-gray-500 leading-8 space-y-2'>
                <div className='py-2'>
                    <p className=''>
                        Running is one of the most effective cardio exercises but not always enjoyed by everyone. An alternative to this is a BodyCombat workout routine 
                        that includes aerobics, muscle strengthening, flexibility, core strengthening, fat loss, stretching and balancing.
                    </p>
                </div>
                <div className='py-2 space-y-2'>
                    <p>
                    This BodyCombat is an action packed workout that guarantees to make us sweat and pumps our heart to a rapid rate.
                    </p>
                    <p>
                    Body combat which is a combination of Kickboxing, Karate, Muay Thai, Tai Chi, Tae Kwon Do etc. has number of benefits.
                    </p>
                </div>
                <div className='relative h-96 max-w-xl'>
                    <Image className='rounded-lg'
                            src={s3Static + "blog/health+and+fitness/body-combat.jpg"}
                            fill
                            style={{objectFit: 'cover'}}
                            placeholder='blur'
                            blurDataURL={s3Static + "placeholder.png"}
                            alt='BodyCombat Singapore'
                    />          
                </div>
                <div className='py-2 space-y-2 text-center'>
                    <h2 className='text-lg font-bold'>
                        Benefits of BodyCombat Workout
                    </h2>
                </div>
                <div className='py-2 space-y-2 px-6'>
                    <h3 className='font-bold'>
                        1. Improves the cardiovascular fitness
                    </h3>
                    <p>
                        This repetitive high intensity workout routine is a massive calorie burner and thus aids to improve the cardiovascular functions of our body.
                    </p>
                    <h3 className='font-bold pt-2'>
                        2. Helps in weight loss
                    </h3>
                    <p>
                        Body combat being a combination of all the above mentioned forms, helps to burn on an average of 600-750 calories for an hour workout. This intense 
                        form of workout serves as a weight loss program and thus helps to lose fat.
                    </p>
                    <h3 className='font-bold pt-2'>
                        3. Helps to tone the muscles
                    </h3>
                    <p>
                        Body combat is a full body workout that trains both the upper and the lower body to transform it in a defined shape and thus helps to tone the muscles.
                    </p>
                    <h3 className='font-bold pt-2'>
                        4. Bodycombat is a big time stress reliever
                    </h3>
                    <p>
                        These power-packed classes carry a strong positive energy which acts as a therapeutic treatment for people in immense stress and pressure. 
                        This in turn acts as a stress reliever.
                    </p>
                    <h3 className='font-bold pt-2'>
                        5. Helps to improve bone density
                    </h3>
                    <p>
                        Bodycombat exercises allows to use low weight and advocates high repetition resistance training which in turn increases our bone density.
                    </p>
                    <h3 className='font-bold pt-2'>
                        6. Helps to boost self confidence
                    </h3>
                    <p>
                        Engaging in bodycombat exercises is a great way to release negative energy. We feel very positive after a body combat exercise or a group class 
                        which in turn helps to stimulate our confidence in ourselves.
                    </p>

                </div>
            </div>
            <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
        </div>
        <div className='fixed bottom-0 w-full text-center text-lg'>
            <Link href="/sg/personal-trainer" prefetch={false} className='text-white py-3 bg-linear-to-tr from-amber-600 to-amber-400 block font-bold w-full'>
                    Find a combat fitness trainer in Singapore
            </Link>
        </div>
      <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
